import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import Payin from 'PMT/entities/Payin';

import PayinsForTable from '../../../../objects/PayinsForTable';

import PayinsTableViewRow from './PayinsTableViewRow';
import PayinsTableViewRowDetail from './PayinsTableViewRowDetail';

export default class PayinsTableView extends Component {

  static propTypes = {
    payins: PropTypes.arrayOf(PayinsForTable),
    totalAmount: PropTypes.number.isRequired,
    totalTips: PropTypes.number.isRequired,
    totalFees: PropTypes.number.isRequired,
    totalTable: PropTypes.number.isRequired,
    currencyCode: PropTypes.string,
  };

  constructor() {
    super();

    // bind functions
    this._toggleToDisplayDetailList = this._toggleToDisplayDetailList.bind(this);
  }

  state = {
    payinsForTableDetailsToDisplay: [] // Array<PayinsForTable>
  };

  _toggleToDisplayDetailList(payinsForTableToToggle: PayinsForTable) {

    let payinsForTableDetailsToDisplay = this.state.payinsForTableDetailsToDisplay;

    // remove on the array to hide the detail
    if (this.isPayinsForTableDetailMustBeDisplay(payinsForTableToToggle)) {
      payinsForTableDetailsToDisplay = _.remove(payinsForTableDetailsToDisplay,
        (elem: PayinsForTable): boolean => {
          return elem.checkId !== payinsForTableToToggle.checkId;
        });
    } else { // add on the array to display the detail
      payinsForTableDetailsToDisplay.push(payinsForTableToToggle);
    }

    this.setState({
      payinsForTableDetailsToDisplay: payinsForTableDetailsToDisplay
    });
  }

  // -- tools
  isPayinsForTableDetailMustBeDisplay(payin: PayinsForTable) {

    const payinsForTableDetailsToDisplay = this.state.payinsForTableDetailsToDisplay;

    const found = _.find(payinsForTableDetailsToDisplay, (elem: PayinsForTable): boolean => {
      return elem.checkId === payin.checkId;
    });

    return !_.isUndefined(found);
  }

  render(): Object {
    let bodyView = [];

    const payins = this.props.payins;

    _.forEach(payins, (payinsForTable: PayinsForTable, key) => {

      let mustDisplayDetail = this.isPayinsForTableDetailMustBeDisplay(payinsForTable);

      bodyView.push(
        <PayinsTableViewRow
          payinsForTable={payinsForTable}
          onToggleDetail={this._toggleToDisplayDetailList}
          key={payinsForTable.checkId}
          detailIsDisplay={mustDisplayDetail}
          currencyCode={this.props.currencyCode}
        />
      );

      // -- Display detail if necessary. Detail is just different rows under the parent row.
      if (mustDisplayDetail) {

        let i = 0;
        payinsForTable.payins.forEach((payin:Payin) => {
          i++;
          bodyView.push(<PayinsTableViewRowDetail payin={payin} key={`${payin.checkId}_${i}`} currencyCode={this.props.currencyCode}/>);
        });


      }

    });

    return (
      <div className="payins_table_view table_container table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th className="col-xs-2">
                {I18n.tr('payins.table.header.date')}
              </th>
              <th className="col-xs-1">
                {I18n.tr('payins.table.header.hour')}
              </th>
              <th className="text-right col-xs-2">
                {I18n.tr('payins.table.header.total_table')}
              </th>
              <th className="text-right col-xs-2">
                {I18n.tr('payins.table.header.payed_with_pmt')}
              </th>
              <th className="text-right col-xs-2">
                {I18n.tr('payins.table.header.including_tips')}
              </th>
              <th className="col-xs-1" />
          </tr>
          </thead>
          <tbody>
          {bodyView}
          </tbody>
        </table>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/payment/receipt/components/PayinsTableView.js